import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import cx from 'classnames';
import _ from 'lodash';
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";

import { TrendsLineChart, TrendsPieChart } from './charts'

import { fetchStoryboardInteractionsReport } from 'actions/storyboardReports';
import { convertDatesToTimezone } from 'services/report.service';
import { EmptyMessage, InteractionAnalyticsHeader, LoadingMessage, TableInfo } from '.';

import { TableFooter } from './tableFooter';
import styles from '../report.module.scss';

export function InteractionAnalytics(props) {
  const dispatch = useDispatch();

  let { storyboardId } = useParams();
  const interactions = useSelector(state => _.get(state, 'storyboards.storyboard.reports.interactions.items'));
  const pagination = useSelector(state => _.get(state, 'storyboards.storyboard.reports.interactions.pagination'));
  const loading = useSelector(state => _.get(state, 'storyboards.storyboard.reports.interactions.loading'));
  const [currentChart, setCurrentChart] = useState("table_view");

  useEffect(() => {
    if (props.date) {
      handlePageChange(0);
    }
  }, [props.date]);

  const handlePageChange = (page) => {
    handleFetchPageViewsReport(page);
  }

  const handleFetchPageViewsReport = (page) => {
    var request = {
      storyboard: storyboardId,
      ...convertDatesToTimezone(props.date),
    }

    dispatch(fetchStoryboardInteractionsReport(request, page, 5));
  }

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  return (
    <div className={styles.interactionAnalyticsWrapper}>
      <div className={styles.interactionAnalyticsContainer}>
        <TableInfo
          name="Interaction Analytics"
          pagination={pagination} />

        <InteractionAnalyticsHeader />

        {currentChart == "table_view" &&
          !loading && interactions && interactions.map((data, index) => {
            return <InteractionReportView data={data} loading={loading} index={index} />
          })
        }

        {currentChart == "graph_view" &&
          <div className={styles.graphSmallView}>
            <TrendsLineChart height={250} />
          </div>
        }

        {currentChart == "pie_chart_view" &&
          <div className={styles.graphSmallView}>
            <TrendsPieChart height={250} width="100%" />
          </div>
        }

        {loading && (interactions && interactions.length > 0) &&
          <LoadingMessage />
        }

        {(interactions && interactions.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view', 'pie_chart_view', 'table_view']}
        handleChartChange={handleChartChange}
        handlePageChange={handlePageChange}
        pagination={pagination}
        leftAlign={true}
        paginationName={"Interactions"}
      />
    </div>
  )
}

function InteractionReportView({ loading, data }) {
  const [tooltip, setTooltip] = useState(false);
  
  if (!data || data.length <= 1) {
    return false;
  }
  
  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  return (
    <div className={styles.interactionAnalyticsRow}>
      <div className={cx(styles.wrapper, styles.pageNameColumn)}>
        <div className={styles.headline}>
          <Tooltip placement="top" content={data.name} disabled={!tooltip}>
            <Truncate onTruncate={handleTooltip} width={130} lines={1}> {data.name} </Truncate>
          </Tooltip>
        </div>
      </div>

      <div className={cx(styles.wrapper, styles.clicksColumn)}>
        <div className={styles.headline}>{data.interactions}</div>
      </div>

      <div className={cx(styles.wrapper, styles.leadsColumn)}>
        <div className={styles.headline}>{data.visitors}</div>
      </div>
    </div>
  )
}